import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreService } from '../../../services/store.service';
import { FormsModule } from '@angular/forms';
import { EmailValidationService } from '../../../services/email-validation.service';
import { VehicleService } from '../../../services/vehicle.service';
import { NotificationService } from '../../../services/notification.service';
import { precioMostrarProducto } from '../../../types/Cart.types';

@Component({
  selector: 'allas-checkout-summary',
  imports: [CommonModule, RouterModule, FormsModule],
  template: `
    <div class="bg-white rounded-lg p-2 h-full flex flex-col fs-condensed">
      <!-- Indicador de productos en la esquina superior derecha -->
      <div class="text-right mb-6 sm:mb-4">
        <span class="font-black text-gray-900 text-sm sm:text-base">
          {{ totalProducts }} PRODUCTOS
        </span>
      </div>

      <!-- Sección DATOS DE CONTACTO -->
      <div class="mb-6 px-3 xl:px-0 sm:mb-8">
        <h3
          class="font-medium text-gray-900 text-lg sm:text-xl mb-2 sm:mb-3 uppercase fs-condensed"
        >
          DATOS DE CONTACTO
        </h3>

        <div class="mb-3 sm:mb-4">
          <label
            class="block font-normal text-gray-900 text-medium mb-2 fs-condensed"
          >
            NOMBRE COMPLETO
          </label>
          <input
            type="text"
            [(ngModel)]="username"
            placeholder="Nombre de usuario"
            class="w-full py-2 px-3 bg-white border border-gray-300 rounded-md text-sm focus:ring-1 focus:ring-allasRed focus:border-allasRed outline-none"
          />
        </div>

        <p class="text-xs sm:text-[10px] text-gray-600 mb-4">
          Es necesario <span class="font-bold">Iniciar Sesión</span> para poder
          solicitar la cotización o comprar
        </p>

        <div class="flex justify-center">
          <a
            routerLink="/login"
            class="mx-4 bg-[#003f87] hover:bg-blue-800 text-white font-normal py-2 px-12 rounded-md text-md transition-colors fs-condensed inline-block text-center"
          >
            INICIAR SESIÓN
          </a>
        </div>
      </div>
      <hr class="my-2" />
      <!-- Sección RESUMEN DE PEDIDO -->
      <!-- <div>
        <h3
          class="font-normal text-gray-900 text-lg sm:text-xl mb-2 sm:mb-3 uppercase fs-condensed"
        >
          RESUMEN DE PEDIDO
        </h3>

        <div>
          <label
            class="block font-normal text-gray-900 text-sm mb-3 ml-2 fs-condensed"
          >
            TOTAL PRODUCTOS
          </label>

          <div class="ml-2 mb-5">
            @for (item of cartItems; track item.id) {
            <div class="text-md mb-1 fs-condensed font-medium">
              {{
                item.producto?.nombre_web ||
                  item.producto?.descripcion ||
                  item.grupo?.name ||
                  'Producto sin nombre'
              }}
            </div>
            }
          </div>
        </div>

        <div class="mt-4">
          <div class="flex justify-between items-center mb-3">
            <span class="text-lg font-medium text-gray-900 fs-condensed">
              SUBTOTAL
            </span>
            <span class="text-lg font-bold text-gray-900">
              L. <span [innerHTML]="formatPrice(getSubtotal())"></span>
            </span>
          </div>

          <div class="flex justify-center">
            <a
              routerLink="/cotizar"
              class="mx-4 bg-[#322b2a] hover:bg-[#96807e] text-white font-normal py-2 px-12 rounded-md text-md transition-colors fs-condensed inline-block text-center"
            >
              COTIZAR AHORA
            </a>
          </div>
        </div>
      </div> -->
      <!-- <hr class="my-4" /> -->
      <!-- Sección LISTA A COTIZAR -->
      <div class="px-3 xl:px-0">
        <h3
          class="font-normal text-gray-900 text-lg sm:text-xl mb-2 sm:mb-3 uppercase fs-condensed"
        >
          LISTA A COTIZAR
        </h3>

        <div class="flex items-center justify-between gap-2 pb-4">
          <label class="font-normal text-gray-900 text-sm ">
            TOTAL PRODUCTOS
          </label>
          <span class="text-sm text-gray-600 font-bold">
            {{ totalProducts }} PRODUCTOS
          </span>
        </div>
        <div>
          <label
            class="flex items-center gap-2 font-normal text-blue-900 text-md fs-condensed"
          >
            <img
              src="images/carrito/front-car-blue.webp"
              alt="Vehículo"
              class="w-5 h-4"
            />
            Vehículo seleccionado
          </label>
          <div class="text-sm text-gray-600 ml-6 mt-1">
            ( {{ getSelectedVehicle() }} )
          </div>
          <div class="mb-3">
            <label
              class="flex items-center gap-2 font-normal text-blue-900 text-md fs-condensed"
            >
              <img
                src="images/carrito/pin-map-blue.webp"
                alt="Tienda"
                class="w-4 h-5"
              />
              Tienda seleccionada
            </label>
            <div class="text-sm text-gray-600 ml-6 mt-1">
              ( {{ getSelectedStore() }} )
            </div>
          </div>
        </div>
        <button
          (click)="emitRequestWhatsAppQuote()"
          class="mt-8 w-full bg-whatsappGreen text-gray-100 font-normal py-2 px-3 rounded-md transition-colors fs-condensed flex items-center justify-center gap-2"
        >
          <img
            src="images/carrito/icons-whatsapp.webp"
            alt="WhatsApp"
            class="w-8 h-8"
          />
          ENVIAR A WHATSAPP
        </button>
      </div>
    </div>
  `,
})
export class CheckoutSummaryComponent {
  @Input() totalProducts: number = 0;
  @Input() cartItems: any[] = [];
  @Output() requestWhatsAppQuote = new EventEmitter<string>();
  username: string = '';

  private emailValidationService = inject(EmailValidationService);
  private storesService = inject(StoreService);
  private vehicleService = inject(VehicleService);
  private notificationService = inject(NotificationService);

  constructor() {
    this.setUsername();
  }

  /**
   * Obtiene el nombre de la tienda seleccionada
   * @returns String con el nombre de la tienda o mensaje por defecto
   */
  getSelectedStore(): string {
    const selectedStore = this.storesService.getSelectedStore();
    return selectedStore?.name || 'No seleccionada';
  }

  /**
   * Calcula el subtotal de todos los productos en el carrito
   * @returns Number con el subtotal
   */
  getSubtotal(): number {
    return this.cartItems.reduce((total, item) => {
      const price = precioMostrarProducto(item.producto);
      const quantity = item.cantidad || 1;
      return total + price * quantity;
    }, 0);
  }

  /**
   * Formatea el precio con la parte entera grande y los decimales en superíndice
   * @param price - Precio a formatear
   * @returns String HTML con el precio formateado
   */
  formatPrice(price: number): string {
    const priceStr = price.toFixed(2);
    const [integerPart, decimalPart] = priceStr.split('.');
    return `${integerPart}<sup class="text-xs font-normal">${decimalPart}</sup>`;
  }

  setUsername() {
    const user = this.emailValidationService.getCurrentUser();
    this.username = user?.nombrePreferido || '';
  }

  getSelectedVehicle(): string {
    const selectedVehicle = this.vehicleService.getDefaultVehicle();
    return selectedVehicle?.alias || 'No seleccionado';
  }

  emitRequestWhatsAppQuote() {
    if (!this.username) {
      this.notificationService.showWarning(
        'Atención',
        'Por favor, ingrese un nombre de usuario para enviar la cotización a WhatsApp'
      );
      return;
    }

    this.notificationService.showSuccess(
      'Enviando cotización a WhatsApp...',
      'Por favor, espera un momento mientras procesamos tu solicitud'
    );

    this.requestWhatsAppQuote.emit(this.username);
  }
}
